const lib = {
	selectors: {
		wrapper: '.logos',
		logoContent: '.logos__container',
	},
	classes: {
		animated: 'logos--animated',
	},
};

/**
 * Animated Logos
 */

const setAnimationDuration = (container: HTMLElement) => {
	const animationTime = 45;
	const innerLength = container.querySelector(lib.selectors.logoContent)?.clientWidth ?? 0;
	const halfOfInnerLength = innerLength / 2;
	container.style.setProperty('--animation-time', `${halfOfInnerLength / animationTime}s`);
};

const initLogoAnimation = (container: HTMLElement) => {
	container.setAttribute('data-animated', 'true');

	const logoContainer = container.querySelector(lib.selectors.logoContent) as HTMLElement;
	const logos = Array.from(logoContainer.children);

	logos.forEach((logo) => {
		const duplicatedItem = logo.cloneNode(true);
		if (!(duplicatedItem instanceof Element)) return;

		duplicatedItem.setAttribute('aria-hidden', 'true');
		logoContainer.appendChild(duplicatedItem);
	});

	setAnimationDuration(container);
};

/**
 * Lazy Loading of Logo Masks
 */

const observer = new IntersectionObserver((entries, observer) => {
	entries.forEach((entry) => {
		const container = entry.target;
		// If the logo container is in the user's field of vision, load the logos.
		if (entry.isIntersecting) {
			// Iterate over each logo and set the mask image url.
			Array.from((container.querySelector(lib.selectors.logoContent) as HTMLElement).children).forEach((logo) => {
				const logoUrl = logo.getAttribute('data-logo');

				if (logo instanceof HTMLElement) {
					logo.removeAttribute('data-logo');
					logo.style.setProperty('--mask-img-url', `url(${logoUrl})`);
					logo.setAttribute('data-logo-loaded', 'true');
				}
			});

			observer.unobserve(container);
		}
	});
});

// Init
window.addEventListener('load', () => {
	document.querySelectorAll<HTMLElement>(lib.selectors.wrapper).forEach((container) => {
		observer.observe(container);

		const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		if (container.classList.contains(lib.classes.animated) && !prefersReducedMotion) {
			initLogoAnimation(container);
		}
	});
});
